import React from 'react';

const DirectoryCard = ({ member }) => {
    return (
        <div className="bg-white rounded-xl shadow-sm hover:shadow-md transition-shadow duration-300 border border-gray-100 overflow-hidden flex flex-col h-full">
            {/* Header / Nomor Keanggotaan */}
            <div className="bg-emerald-50 px-5 py-3 border-b border-emerald-100 flex justify-between items-center">
                <span className="text-xs font-bold text-emerald-700 tracking-wider">NO. ANGGOTA</span>
                <span className="text-sm font-mono font-semibold text-emerald-900 bg-emerald-200/50 px-2 py-1 rounded">
                    {member.membership_number}
                </span>
            </div>

            {/* Body */}
            <div className="p-5 flex-1 flex flex-col">
                <h3 className="text-lg font-bold text-gray-900 mb-4 line-clamp-2">
                    {member.pesantren_name}
                </h3>

                <div className="mt-auto space-y-3">
                    {/* Lokasi */}
                    <div className="flex items-start text-sm text-gray-600">
                        <svg className="w-5 h-5 text-gray-400 mr-2 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                        </svg>
                        <span>
                            {member.city_name}, <br />
                            <span className="text-gray-500">{member.province_name}</span>
                        </span>
                    </div>

                    {/* Bidang Usaha (semua bidang) */}
                    <div className="flex items-start text-sm text-gray-600">
                        <svg className="w-5 h-5 text-gray-400 mr-2 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                        </svg>
                        <div className="flex flex-wrap gap-1.5">
                            {(member.business_type_names || []).map((name) => (
                                <span key={name} className="px-2 py-0.5 rounded-full text-xs font-medium bg-emerald-50 text-emerald-900 border border-emerald-100">
                                    {name}
                                </span>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DirectoryCard;